import { useState } from 'react';
import { toast } from 'sonner';
import { useVenue } from '../contexts/VenueContext';
import { crossAppSwitchVenue } from '../utils/roleSwitchFlow';

/**
 * Drives the merged venue-switcher dropdown (top-left, in both the owner
 * app and the staff app). `allVenues` mixes the user's own venue(s) with
 * their single staff/admin venue (if any) — see `VenueContext`. Selecting
 * an entry that's already in the CURRENT app scope is a cheap in-place
 * swap (`switchVenue`, no reload). Selecting one from the OTHER scope
 * (e.g. tapping your staff venue while inside the owner app) swaps the
 * role token and navigates into the correct app tree.
 */
export function useVenueSwitcher() {
  const { activeVenue, allVenues, switchVenue, scope } = useVenue();
  const [switching, setSwitching] = useState(false);

  const selectVenue = async (venue) => {
    if (!venue || venue.id === activeVenue?.id || switching) return;
    const isStaffEntry = Boolean(venue.staff_role);
    const currentlyStaffScope = scope === 'staff';
    if (isStaffEntry === currentlyStaffScope) {
      switchVenue(venue.id);
      return;
    }
    setSwitching(true);
    try {
      await crossAppSwitchVenue(venue);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Unable to switch venue right now');
      setSwitching(false);
    }
  };

  return { venues: allVenues, activeVenue, selectVenue, switching };
}
